// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V3$Linear from "./V3.res.js";
import * as M33$Linear from "./M33.res.js";
import * as V3f$Linear from "./V3f.res.js";
import * as M22f$Linear from "./M22f.res.js";

let zero = M33$Linear.fill(0);

function scalar(value) {
  return [
    [
      value,
      0,
      0
    ],
    [
      0,
      value,
      0
    ],
    [
      0,
      0,
      value
    ]
  ];
}

let identity = scalar(1);

function scale(m, s) {
  return M33$Linear.map(m, e => e * s);
}

function determinant(param) {
  let match = param[2];
  let i = match[2];
  let h = match[1];
  let match$1 = param[1];
  let f = match$1[2];
  let e = match$1[1];
  let match$2 = param[0];
  let c = match$2[2];
  let b = match$2[1];
  return match$2[0] * (e * i - f * h) - match$1[0] * (b * i - c * h) + match[0] * (b * f - c * e);
}

function inverse(m) {
  let cofactor = (q, r, s, t) => M22f$Linear.determinant([
    [
      q,
      r
    ],
    [
      s,
      t
    ]
  ]);
  let match = m[2];
  let i = match[2];
  let h = match[1];
  let g = match[0];
  let match$1 = m[1];
  let f = match$1[2];
  let e = match$1[1];
  let d = match$1[0];
  let match$2 = m[0];
  let c = match$2[2];
  let b = match$2[1];
  let a = match$2[0];
  let a$p = cofactor(e, f, h, i);
  let b$p = cofactor(c, b, i, h);
  let c$p = cofactor(b, c, e, f);
  let d$p = cofactor(f, d, i, g);
  let e$p = cofactor(a, c, g, i);
  let f$p = cofactor(c, a, f, d);
  let g$p = cofactor(d, e, g, h);
  let h$p = cofactor(b, a, h, g);
  let i$p = cofactor(a, b, d, e);
  return scale([
    [
      a$p,
      b$p,
      c$p
    ],
    [
      d$p,
      e$p,
      f$p
    ],
    [
      g$p,
      h$p,
      i$p
    ]
  ], 1 / determinant(m));
}

function v3f(a, b) {
  return V3$Linear.map(a, row => V3f$Linear.dot(row, b));
}

function m33f(a, b) {
  let bcols = M33$Linear.transpose(b);
  return V3$Linear.map(a, row => V3$Linear.map(bcols, col => V3f$Linear.dot(row, col)));
}

let Mult = {
  v3f: v3f,
  m33f: m33f
};

let jsonCodec = M33$Linear.jsonCodec(Jzon.float);

export {
  zero,
  scalar,
  identity,
  scale,
  determinant,
  inverse,
  Mult,
  jsonCodec,
}
/* zero Not a pure module */
